import React, { useEffect, useState } from 'react';
import { Container, Typography, CircularProgress, Alert, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyEmail as apiVerifyEmail } from '../services/api/auth';
import { showAlert } from '../components/service/AlertService';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const { actualTheme } = useTheme();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError(t('verifyEmail.invalidToken'));
      setLoading(false);
      return;
    }

    const verify = async () => {
      try {
        const response = await apiVerifyEmail(token);
        if (response.data) {
            const newUser = {
              username: response.data.username,
              token: response.data.token
            };
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(newUser));
            setUser(newUser);
            setLoading(false);

            setSuccess(true);
            showAlert('EMAIL_VERIFICATION_SUCCESSFULLY');
            
            // Wait for a moment before navigating to the activity page
            await new Promise(resolve => setTimeout(resolve, 5000)); // 5 second delay
            navigate('/activity');
        } else {
            showAlert(response.error.code);
          throw new Error(t('verifyEmail.error'));
        }
      } catch (err) {
        setError(t('verifyEmail.error'));
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [searchParams, t]);

  return (
    <Container maxWidth="sm" sx={{ mt: 12, mb: 4 }}>
      <Paper
        sx={{
          p: 4,
          background: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(10px)',
          borderRadius: 2,
          border: '1px solid rgba(255, 255, 255, 0.1)',
          textAlign: 'center'
        }}
      >
        {loading && (
          <>
            <CircularProgress sx={{ mb: 3 }} />
            <Typography
              variant="h6"
              sx={{ color: actualTheme === 'dark' ? '#ffffff' : '#000000' }}
            >
              {t('verifyEmail.verifying')}
            </Typography>
          </>
        )}

        {!loading && success && (
          <>
            <Alert severity="success" sx={{ mb: 3 }}>
              {t('verifyEmail.success')}
            </Alert>
          </>
        )}

        {!loading && error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}
      </Paper>
    </Container>
  );
};

export default VerifyEmail;
